import { Injectable } from '@angular/core';
import { DbRecord } from './db-record'
import { Project } from './project'
import { Criterion } from './criterion'
import { UtilsService } from './utils.service'
import { ArcService } from './arc.service'
import { RuntimeService } from './runtime.service'
import { ProjectService } from './project.service'
import { CriterionService } from './criterion.service'
import { FilterService } from './filter.service'
import { PatentService } from './patent.service'

@Injectable()
export class DbRecordService {
  dbRecordsMap = new Map<string, Map<string, DbRecord>>();
  duplicatesMap = new Map<string, Map<string, Set<DbRecord>>>();
  manualMap = new Map<string, Map<string, DbRecord>>();
  repairMap = new Map<string, Object>();
  patentFamilyMap = new Map<string, Set<DbRecord>>();
  currentExcludeRecordsSet = new Set<string>();

  currentProject: Project;
  uniqueLists = new Map<string, DbRecord[]>();
  duplicatesLists = new Map<string, DbRecord[]>();
  rts: RuntimeService;
  cs: CriterionService;
  private _editedRecords = new Set<DbRecord>();

  constructor(
    private arcs: ArcService,
    public utils: UtilsService,
    public fs: FilterService,
    public ps: PatentService
  ) {
    this.fs.dbrs = this;
  }

  getDbRecord(id: string) {
      return this.dbRecordsMap.get(this.rts.currentProject.id).get(id);
  }

  processPatentFamily(ls: DbRecord[]) {
    ls.forEach(x => {
      x.publicationNumbers.forEach(pn => {
        let s = this.patentFamilyMap.get(pn);
        if (!s) {
          s = new Set<DbRecord>();
          this.patentFamilyMap.set(pn, s);
        }
        ls.forEach(y => {
          s.add(y)
        });
      });
    });
  }

  getRepairObject(recordId: string) {
    let data = this.repairMap.get(this.currentProject.id);
    if (!data) {
      return;
    }
    return data[recordId];
  }

  switchEditedRecord(dbRecord: DbRecord) {
    if (!this._editedRecords.delete(dbRecord)) {
      this._editedRecords.add(dbRecord);
    }
  }

  isEditedRecord(dbRecord: DbRecord) {
    return this._editedRecords.has(dbRecord);
  }

  create(obj: Object) {
    return new DbRecord(this, obj);
  }

  newManual() {
    return this.create({
      recordId: `m_${this.utils.uniqueIdentifier}`,
      isManual: true
    });
  }

  cancelSave(dbRecord: DbRecord) {
    this.switchEditedRecord(dbRecord);
  }

  save(dbRecord: DbRecord) {
    let p = this.rts.currentProject;
    let dbr = dbRecord.seed();

    let obs = this.arcs.run({
      fun: 'saveRecord',
      projectId: p.id,
      projectShortcut: p.shortcut,
      record: dbr,
      isManual: dbRecord._isManual
    });

    obs.subscribe((resp) => {
      dbRecord.clearCriterionTextCache();
      this.cs.clearRecordCache(dbRecord);
      this.switchEditedRecord(dbRecord);
    });
  }


  getProjectRecords(project: Project) {
    return this.dbRecordsMap.get(project.id);
  }

  getDuplicates(project: Project) {
    return this.duplicatesMap.get(project.id);
  }

  initProjectData(project: Project) {
    this.currentProject = project;
    if (!this.getProjectRecords(project)) {
      this.dbRecordsMap.set(project.id, new Map<string, DbRecord>());
      this.duplicatesMap.set(project.id, new Map<string, Set<DbRecord>>());
    }
  }

  getCriterion(id: string): Criterion {
    return this.currentProject.criterionsMap.get(id);
  }


  addManualRecord(dbRecord: DbRecord) {
    let projectMap = this.manualMap.get(this.currentProject.id);
    if (!projectMap) {
      projectMap = new Map<string, DbRecord>();
      this.manualMap.set(this.currentProject.id, projectMap);
    }
    projectMap.set(dbRecord.id, dbRecord);
  }


  addDbRecord(dbRecord: DbRecord) {
    this.getProjectRecords(this.currentProject).set(dbRecord.id, dbRecord);
    if (dbRecord._isManual) {
      return this.addManualRecord(dbRecord);
    }

    let m = this.getDuplicates(this.currentProject);
    dbRecord.keys.forEach((k) => {
      let sss = m.get(k);
      if (!sss) {
        sss = new Set<DbRecord>();
        m.set(k, sss);
      }
      sss.add(dbRecord);
    });
  }

  prepareLists() {
    let priorities = { espacenet: 1, wos: 2, scopus: 3, cas: 4, pubmed: 5 };
    let m = this.getDuplicates(this.currentProject);
    let uniqueSet = new Set<DbRecord>();
    let duplicatesSet = new Set<DbRecord>();

    m.forEach((s) => {
      let topDbRecord;
      s.forEach((dbr) => {
        if (!topDbRecord || priorities[topDbRecord] < priorities[dbr._sourceDb]) {
          topDbRecord = dbr;
          if (!duplicatesSet.has(dbr)) {
            uniqueSet.add(dbr);
          }
        } else {
          duplicatesSet.add(dbr);
          uniqueSet.delete(dbr);
        }
      });
    });

    this.uniqueLists.set(this.currentProject.id, Array.from(uniqueSet));
    this.duplicatesLists.set(this.currentProject.id, Array.from(duplicatesSet));
    this.currentProject.isInitialized = true;
  }

  getTotalDbRecordsCount(project: Project) {
    return this.getProjectRecords(project).size;
  }

  getUniqueDbRecordsCount(project: Project) {
    let c = (this.uniqueLists.get(project.id) || []).length;
    let mm = this.manualMap.get(project.id);
    if (!mm)
      return c;
    return c + mm.size;
  }

  getProjectDbRecordsList(project: Project) {
    let mm = this.manualMap.get(project.id);
    let mmLs = [];

    if (mm)
      mm.forEach((dbr) => mmLs.push(dbr));

    return (this.uniqueLists.get(project.id) || []).concat(mmLs);
  }

}



// WEBPACK FOOTER //
// ./src/app/db-record.service.ts